<script lang="ts" setup>
import { getCssVar } from 'quasar';
import { LinkBtnProps } from './_types';

const props = withDefaults(defineProps<LinkBtnProps>(), {
    activeColor: 'secondary',
    textColor: 'primary',
    square: true,
});
const activeColor = computed(() => getCssVar(props.activeColor || '') || props.activeColor);
const textColor = computed(() => getCssVar(props.textColor || '') || props.textColor);
</script>
<template>
    <q-btn
        v-bind="props"
        class="app-btn app-btn-link app-btn--no-q-hover text-bold"
        flat
        :text-color="textColor"
        :style="{ '--app-btn-link--text-color': textColor, '--app-btn-link--active-color': activeColor }"
        no-caps
        :ripple="false"
    >
        <q-tooltip v-if="tooltip" :square="square">{{ tooltip }}</q-tooltip>

        <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
            <slot :name="slotName" v-bind="slotProps || {}" />
        </template>
    </q-btn>
</template>
